const React = require('react');
const Ripple = require('../Ripple');


module.exports = (props) => {
  return (
    <Ripple
      {...props}
      className={`dn wmin230 h55 r4 layoutRow ph24 lts.015em tdN olN usN
        bgF.06 bgF.1:not[.disabled]:h fhaC fvaC cF lh fw6 f15 ov
        (o50|crNA).disabled*2 `
        + (props.className || '')}
    >
      <div
        className="rlv st-1"
      >{props.children}</div>
    </Ripple>
  );
};
